// src/client/utils/dates.ts
// All functions accept ISO strings and an optional `now` for deterministic tests.

const MS_PER_DAY = 86_400_000;

// Normalize a Date to the start of its local calendar day. Two Dates that share
// a local calendar day return the same value; subtracting two such values and
// rounding by MS_PER_DAY gives the calendar-day delta (DST-safe via round).
const startOfLocalDay = (d: Date): number =>
  new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

export function daysUntil(iso: string, now: Date = new Date()): number {
  const target = startOfLocalDay(new Date(iso));
  const base = startOfLocalDay(now);
  return Math.round((target - base) / MS_PER_DAY);
}

export function formatDueIn(iso: string, now: Date = new Date()): string {
  const d = daysUntil(iso, now);
  if (d > 1) return `Due in ${d} days`;
  if (d === 1) return 'Due tomorrow';
  if (d === 0) return 'Due today';
  return `${Math.abs(d)} days overdue`;
}

export function formatLongDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric',
  });
}
